import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  HowDidYouHearAboutUsOption,
  HowDidYouHearAboutUsOptionSort
} from '../../lib/types/models/how-did-you-hear-about-us-option/how-did-you-hear-about-us-option'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getHowDidYouHearAboutUs(
  input: PaginationRequest<null, never, never, HowDidYouHearAboutUsOptionSort> = {}
) {
  if (!input.sort) input.sort = { name: 'asc' }
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.howDidYouHearAboutUs.getAll.url, null), input))
    .get<PaginationResponse<HowDidYouHearAboutUsOption>>()
}
